import React from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { SimpleTooltip } from "simple-ui-components";

import { AuthProvider } from "./components/authContextProvider";
import { PrivateRoute } from "./components/shared/privateRoute";
import { CurrentTheme, GlobalStyle } from "./theme";
import { LanguageProvider } from "./components/languageProvider";
import { Login } from "./components/login/login";
import { ForgotPassword } from "./components/login/forgotPassword";
import { PageNotFound } from "./components/pageNotFound/pageNotFound";
import { Dashboard } from "./components/dashboard/dashboard";
import { Equipments } from "./components/equipments/equipments";
import { Clients } from "./components/clients/clients";
import { Accounts } from "./components/accounts/accounts";
import { Profile } from "./components/profile/profile";
import Reports from "./components/reports/reports";
import { Routes as RoutesPage } from "./components/routes/routes";
import { Repairs } from "./components/repairs/repairs";
import { GenerateReports } from "./components/generateReports/generateReports";
import Vehicles from "./components/vehicles/vehicles";

export const App = () => {
  const { TooltipContainer } = SimpleTooltip;
  return (
    <ThemeProvider theme={CurrentTheme}>
      <AuthProvider>
        <LanguageProvider>
          <Routes>
            <Route path="/" exact element={<Login />} />
            <Route exact path="/forgotPassword" element={<ForgotPassword />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/equipments"
              element={
                <PrivateRoute>
                  <Equipments />
                </PrivateRoute>
              }
            />
            <Route
              path="/clients"
              element={
                <PrivateRoute>
                  <Clients />
                </PrivateRoute>
              }
            />
            <Route
              path="/accounts"
              element={
                <PrivateRoute>
                  <Accounts />
                </PrivateRoute>
              }
            />
            <Route
              path="/vehicles"
              element={
                <PrivateRoute>
                  <Vehicles />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/routes"
              element={
                <PrivateRoute>
                  <RoutesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/repairs"
              element={
                <PrivateRoute>
                  <Repairs />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/generateReport"
              element={
                <PrivateRoute>
                  <GenerateReports />
                </PrivateRoute>
              }
            />

            <Route element={<PageNotFound />} />
          </Routes>
        </LanguageProvider>
      </AuthProvider>
      <TooltipContainer />
      <GlobalStyle theme={CurrentTheme} />
    </ThemeProvider>
  );
};
